import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  TopToolbar,
  SearchInput,
  TextInput,
  Filter,
  FunctionField,
} from 'react-admin';
import { Card, Typography, Box } from '@mui/material';
import {
  Add as AddIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
} from '@mui/icons-material';
import DeleteWithPasswordButton from '@/components/DeleteWithPasswordButton';
import CustomCreateButton from '@/components/CustomCreateButton';

const ClientListActions = () => (
  <TopToolbar>
    <CustomCreateButton
      variant='contained'
      label='Crear Cliente'
      icon={<AddIcon />}
      sx={{
        height: '40px',
        backgroundColor: 'primary.main',
        '&:hover': {
          backgroundColor: 'primary.dark',
        },
      }}
    />
  </TopToolbar>
);

const ClientFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput
      source='q'
      placeholder='Buscar clientes...'
      alwaysOn
      size='small'
      sx={{ minWidth: 200, mb: 0.5 }}
    />
    <TextInput label='Nombre del Cliente' source='clientName' resettable />
    <TextInput label='Email' source='clientEmail' resettable />
    <TextInput label='Teléfono' source='clientPhoneContact' resettable />
  </Filter>
);

const ClientNameField = ({ record }: any) => {
  if (!record) return null;

  return (
    <Box display='flex' alignItems='center' gap={1}>
      <BusinessIcon color='action' fontSize='small' />
      <span>{record.clientName || 'Sin nombre'}</span>
    </Box>
  );
};

const ContactInfoField = ({ record }: any) => {
  if (!record) return null;

  return (
    <Box display='flex' flexDirection='column' gap={0.5}>
      {record.clientEmail && (
        <Box display='flex' alignItems='center' gap={1}>
          <EmailIcon fontSize='small' color='action' />
          <span style={{ fontSize: '0.875rem' }}>{record.clientEmail}</span>
        </Box>
      )}
      {record.clientPhoneContact && (
        <Box display='flex' alignItems='center' gap={1}>
          <PhoneIcon fontSize='small' color='action' />
          <span style={{ fontSize: '0.875rem' }}>
            {record.clientPhoneContact}
          </span>
        </Box>
      )}
    </Box>
  );
};

export const ClientsList: React.FC = () => (
  <Card elevation={1} sx={{ m: 2, p: 2 }}>
    <Box sx={{ p: 3, pt: 2, pb: 2.5, borderBottom: 1, borderColor: 'divider' }}>
      <Typography
        variant='h5'
        component='h1'
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <PeopleIcon color='primary' />
        Gestión de Clientes
      </Typography>
    </Box>
    <List
      title={false}
      sort={{ field: 'clientName', order: 'ASC' }}
      perPage={25}
      filters={<ClientFilter />}
      actions={<ClientListActions />}
      sx={{ '& .RaList-main': { mt: 0 } }}
    >
      <Datagrid
        rowClick='show'
        sx={{ '& .RaDatagrid-headerCell': { fontWeight: 'bold' } }}
      >
        <TextField source='id' label='ID' />
        <FunctionField
          label='Cliente'
          render={(record: any) => <ClientNameField record={record} />}
        />
        <FunctionField
          label='Información de Contacto'
          render={(record: any) => <ContactInfoField record={record} />}
        />
        <TextField source='clientAddress' label='Dirección' />
        <ShowButton label={''} />
        <EditButton label={''} />
        <DeleteWithPasswordButton resource='clients' label='Eliminar' />
      </Datagrid>
    </List>
  </Card>
);

export default ClientsList;
